/* eslint-disable no-nested-ternary */
/* eslint-disable react/require-default-props */
import React, { FC } from 'react';
import { IExternalLinkProps } from '../../models/Contentful/types';

interface CExternalLinkProps extends IExternalLinkProps {
  classes?: string;
  children?: React.ReactNode;
  ariaLabel?: string;
}

const ExternalLink: FC<CExternalLinkProps> = ({
  name,
  url,
  classes = '',
  children,
  layout,
  diffTab = true,
  showName,
  text = '',
  ariaLabel,
}) => {
  const layoutClass =
    layout === 'Primary'
      ? 'is-primary'
      : layout === 'Secondary'
        ? 'is-secondary'
        : layout === 'Text'
          ? 'is-text'
          : '';

  return (
    <a
      href={url}
      target={diffTab ? '_blank' : '_self'}
      rel="noreferrer"
      className={`${classes} ${layoutClass}`}
      aria-label={ariaLabel}
    >
      {children}
      {!children && ((showName && name) ?? text ?? '')}
    </a>
  );
};

export default ExternalLink;
